export default __webpack_public_path__ + "static/media/junk8.932499a6.svg";